import SearchInvoice from "views/admin/Invoice/SearchInvoice";
import axiosInstance from "./base";

const userResources = {
  userVerify: (id) => {
    return axiosInstance.get(`/user/verify/${id}`);
  },
  login: (data) => {
    return axiosInstance.post("/login", data);
  },
  register: (data) => {
    return axiosInstance.post("/register", data);
  },
  employeeRegister: (data) => {
    return axiosInstance.post("/user/employee-register", data);
  },
  logout: () => {
    return axiosInstance.get("/user/logout");
  },
  superAdminUpdatePassord: (data) => {
    return axiosInstance.post("/user/change-user-password", data);
  },
  role: () => {
    return axiosInstance.get("/roles/list");
  },
  updateprofile: (data, token) => {
    return axiosInstance.post("/user/update-user-details", data, {
      headers: {
        Authorization: `Bearer ${token}`, // Attach the token for authentication
      },
    });
  },
  createEnquiry: (data) => {
    return axiosInstance.post("/enquiries/save-and-update", data);
  },
  createEnquiryMultiWay: (data) => {
    return axiosInstance.post("/enquiries/save-and-update-multiple", data);
  },
  createEnquiryMultiWayByAgent: (data) => {
    return axiosInstance.post(
      "/assign-enquiries/save-and-update-multiple",
      data
    );
  },
  createEnquiryRoundAndOneWayByAgent: (data) => {
    return axiosInstance.post("/assign-enquiries/save-and-update", data);
  },
  createEnquiryMulticityByAgent: (data) => {
    return axiosInstance.post(
      "/assign-enquiries/save-and-update-multiple",
      data
    );
  },

  enquiryList: (params) => {
    const url = "/enquiries/list";

    // Use Axios's params option to handle query parameters automatically
    return axiosInstance.get(url, { params });
  },
  enquiryListAll: (params) => {
    const url = "/enquiries/all-enquiries";

    // Use Axios's params option to handle query parameters automatically
    return axiosInstance.get(url, { params });
  },
  searchEnquiryList: (data) => {
    return axiosInstance.post("/enquiries/search-flight", data);
  },

  enquiryAssignList: (params) => {
    const url = "/assign-enquiries/list";

    // Use Axios's params option to handle query parameters automatically
    return axiosInstance.get(url, { params });
  },
  assignEnquiryAccepter: (data) => {
    const params = {
      status: data.status,
    };
    return axiosInstance.post(`/enquiries/accept-or-reject/${data.id}`, params);
  },
  enquiryDelete: (id) => {
    return axiosInstance.delete(`/enquiries/delete/${id}`);
  },
  userList: ({ role_id, page = 0, size = 9999, globalFilter }) => {
    let url = "/user/user-list";
    const params = [];

    // Add role_id if provided
    if (role_id) {
      params.push(`role_id=${role_id.value || role_id}`);
    }

    // Add pagination defaults if not provided
    params.push(`page=${page + 1}`); // Assuming 1-based page index for API
    params.push(`limit=${size}`);

    // Add global filter if provided
    if (globalFilter) {
      params.push(`email=${globalFilter}`);
    }

    // Append all params to the URL
    if (params.length) {
      url += `?${params.join("&")}`;
    }
    return axiosInstance.get(url);
  },
  adminemployeeslist: (page = 0, size = 9999, searchParams = {}) => {
    let url = "/user/admin-employee-list";
    const queryParams = [];

    // Add pagination params
    if (page !== undefined) {
      queryParams.push(`page=${page + 1}`);
    }
    if (size !== undefined) {
      queryParams.push(`limit=${size}`);
    }

    // Add search params (e.g., name)
    if (searchParams.name) {
      queryParams.push(`name=${searchParams.name}`);
    }

    // If there are any query params, add them to the URL
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    // Send the GET request with the constructed URL
    return axiosInstance.get(url);
  },
  userDelete: (id) => {
    return axiosInstance.delete(`/user/delete/${id}`);
  },
  addAirlines: (data) => {
    return axiosInstance.post("/air-lines/save-and-update", data);
  },
  addAirpost: (data) => {
    return axiosInstance.post("/world-airports/save-and-update", data);
  },
  airportDataList: (data) => {
    return axiosInstance.get(`/world-airports/list`, { params: data });
  },
  airportDelete: (id) => {
    return axiosInstance.delete(`/world-airports/delete/${id}`);
  },
  // Assuming userResources is already defined and axiosInstance is configured
  airlines: (page = 0, size = 10, globalFilter, airlineCode) => {
    let url = "/air-lines/list";
    const params = [];

    // Since page and size have default values, they’ll be used if not provided
    params.push(`page=${page + 1}`);
    params.push(`limit=${size}`);
    if (airlineCode) {
      params.push(`airline_code=${airlineCode}`);
    }
    if (globalFilter) {
      // Check for a non-empty string here
      params.push(`airline_name=${globalFilter}`);
    }

    // If there are any parameters, add them to the URL
    if (params.length) {
      url += `?${params.join("&")}`;
    }

    return axiosInstance.get(url);
  },

  airlinesDelete: (id) => {
    return axiosInstance.delete(`/air-lines/delete/${id}`);
  },
  departments: (page = 0, size = 9999, globalFilter) => {
    let url = "/departments/list";

    // Add query parameters only if they are present
    const params = [];
    if (page !== undefined) {
      params.push(`page=${page + 1}`);
    }
    if (size !== undefined) {
      params.push(`limit=${size}`);
    }

    if (globalFilter !== undefined) {
      params.push(`departments=${globalFilter}`);
    }

    // If there are any parameters, add them to the URL
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return axiosInstance.get(url);
  },
  addDepartments: (data) => {
    return axiosInstance.post("/departments/save-and-update", data);
  },
  departmentDelete: (id) => {
    return axiosInstance.delete(`/departments/delete/${id}`);
  },
  transactionType: (page = 0, size = 9999, globalFilter) => {
    let url = "/transaction-type/list";

    // Add query parameters only if they are present
    const params = [];
    if (page !== undefined) {
      params.push(`page=${page + 1}`);
    }
    if (size !== undefined) {
      params.push(`limit=${size}`);
    }

    if (globalFilter !== undefined) {
      params.push(`transactionType=${globalFilter}`);
    }

    // If there are any parameters, add them to the URL
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return axiosInstance.get(url);
  },
  addTransactionType: (data) => {
    return axiosInstance.post("/transaction-type/save-and-update", data);
  },
  transactionTypeDelete: (id) => {
    return axiosInstance.delete(`/transaction-type/delete/${id}`);
  },

  branch: (page = 0, size = 9999, globalFilter) => {
    let url = "/branches/list";

    // Add query parameters only if they are present
    const params = [];
    if (page !== undefined) {
      params.push(`page=${page + 1}`);
    }
    if (size !== undefined) {
      params.push(`limit=${size}`);
    }

    if (globalFilter !== undefined) {
      params.push(`departments=${globalFilter}`);
    }

    // If there are any parameters, add them to the URL
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return axiosInstance.get(url);
  },
  addBranch: (data) => {
    return axiosInstance.post("/branches/save-and-update", data);
  },
  branchDelete: (id) => {
    return axiosInstance.delete(`/branches/delete/${id}`);
  },
  supplier: (params) => {
    let url = "/suppliers/list";
    return axiosInstance.get(url, { params });
  },

  addSupplier: (data) => {
    return axiosInstance.post("/suppliers/save-and-update", data);
  },
  supplierDelete: (id) => {
    return axiosInstance.delete(`/suppliers/delete/${id}`);
  },
  createStatus: (data) => {
    return axiosInstance.post("/enquiries-status/save-and-update", data);
  },
  enquityStatus: (page = 0, size = 9999, globalFilter) => {
    let url = "/enquiries-status/list";

    // Add query parameters only if they are present
    const params = [];
    if (page !== undefined) {
      params.push(`page=${page + 1}`);
    }
    if (size !== undefined) {
      params.push(`limit=${size}`);
    }
    if (globalFilter !== undefined) {
      params.push(`enquiries-source=${globalFilter}`);
    }

    // If there are any parameters, add them to the URL
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return axiosInstance.get(url);
  },
  enquiryStatusDelete: (id) => {
    return axiosInstance.delete(`/enquiries-status/delete/${id}`);
  },
  createSource: (data) => {
    return axiosInstance.post("/enquiries-source/save-and-update", data);
  },
  sourceDelete: (id) => {
    return axiosInstance.delete(`/enquiries-source/delete/${id}`);
  },
  getSources: (page = 0, size = 9999, globalFilter) => {
    let url = "/enquiries-source/list";

    // Add query parameters only if they are present
    const params = [];
    if (page !== undefined) {
      params.push(`page=${page + 1}`);
    }
    if (size !== undefined) {
      params.push(`limit=${size}`);
    }
    if (globalFilter !== undefined) {
      params.push(`enquiries-source=${globalFilter}`);
    }

    // If there are any parameters, add them to the URL
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return axiosInstance.get(url);
  },
  addHotel: (data) => {
    return axiosInstance.post("/hotel-enquire/save-and-update", data);
  },
  hotelList: (params) => {
    const url = "/hotel-enquire/list";

    // Use Axios's params option to handle query parameters automatically
    return axiosInstance.get(url, { params });
  },
  hotelEnquiryDelete: (id) => {
    return axiosInstance.delete(`/hotel-enquire/delete/${id}`);
  },
  hotelAssignEnquiryAccepter: (data) => {
    const params = {
      status: data.status,
    };
    return axiosInstance.post(
      `/hotel-enquire/accept-or-reject/${data.id}`,
      params
    );
  },
  hotelEnquiryAssignList: (params) => {
    const url = "/assign-hotel-enquiries/list";

    // Use Axios's params option to handle query parameters automatically
    return axiosInstance.get(url, { params });
  },
  hotelAdminPaymentApprovel: (data) => {
    const params = {
      admin_payment_status: data?.admin_payment_status,
    };
    return axiosInstance.post(
      `/hotel-enquire/accept-or-reject-by-admin/${data?.id}`,
      params
    );
  },
  searchHotelEnquiryList: (data) => {
    return axiosInstance.post("/hotel-enquire/search-hotel-enquiry", data);
  },
  createAssignedEnquirys: (data) => {
    return axiosInstance.post("/assign-hotel-enquiries/save-and-update", data);
  },
  createdHotelEnquiryList: (params) => {
    const url = "/hotel-enquire/created-by-employee";

    // Use Axios's params option to handle query parameters automatically
    return axiosInstance.get(url, { params });
  },

  dashboardStatics: (params) => {
    return axiosInstance.post("/statics/list", params);
  },
  hoteldashboardStatics: (params) => {
    return axiosInstance.post("/statics/hotel-list", params);
  },
  hotelprofileStatics: (params) => {
    return axiosInstance.post("/statics/profile-hotel-enquires", params);
  },

  profileStatics: (params) => {
    return axiosInstance.post("/statics/profile-statics", params);
  },
  markAttendance: () => {
    return axiosInstance.get("/attendance/mark-attendance");
  },
  getAttendance: () => {
    return axiosInstance.get("/attendance/list");
  },
  deleteinvoiceRecord: (id) => {
    return axiosInstance.delete(`/invoices/delete/${id}`);
  },
  notification: () => {
    return axiosInstance.get("/notifications/list");
  },
  adminPaymentApprovel: (data) => {
    const params = {
      admin_payment_status: data?.admin_payment_status,
    };
    return axiosInstance.post(
      `/enquiries/accept-or-reject-by-admin/${data?.id}`,
      params
    );
  },
  phoneNumbersList: (data) => {
    return axiosInstance.get("/phone_numbers/list", {
      params: { page: data.currentPage, limit: data.perPageLimit },
    });
  },
  uploadMedia: (data) => {
    return axiosInstance.post(`/media/upload`, data);
  },
  deletePhoneNumbers: (id) => {
    return axiosInstance.delete(`/phone_numbers/delete/${id}`);
  },
  AddphoneNumbers: (data) => {
    return axiosInstance.post("/phone_numbers/save-and-update", data);
  },
  sendWhatsappMsg: (data) => {
    return axiosInstance.post("/messages/send", data);
  },
  sendMsg: (data) => {
    return axiosInstance.post(`/live-chat/chats`, data);
  },

  getChatMessages: (data) => {
    return axiosInstance.get(`/live-chat/chats/${data.receiver}`);
  },
  instaEnquiry: (data) => {
    return axiosInstance.post("/flight-booking-enquiry/save-and-update", data);
  },
  instaEnquiryList: (page, size, globalFilter) => {
    let url = "/flight-booking-enquiry/list";

    // Add query parameters only if they are present
    const params = [];
    if (page !== undefined) {
      params.push(`page=${page + 1}`);
    }
    if (size !== undefined) {
      params.push(`limit=${size}`);
    }
    if (globalFilter !== undefined) {
      params.push(`email=${globalFilter}`);
    }

    // If there are any parameters, add them to the URL
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return axiosInstance.get(url);
  },
  instaEnquiryDelete: (id) => {
    return axiosInstance.delete(`/flight-booking-enquiry/delete/${id}`);
  },
  setFollowUp: (id, data) => {
    return axiosInstance.post(`/flight-enquiry-follow-up/${id}`, data);
  },
  addOtherEnquiry: (data) => {
    return axiosInstance.post("/other-services/save-and-update", data);
  },
  otherenquiryListAll: (params) => {
    const url = "/other-services/list";
    // Use Axios's params option to handle query parameters automatically
    return axiosInstance.get(url, { params });
  },
  otherAdminPaymentApprovel: (data) => {
    const params = {
      admin_payment_status: data?.admin_payment_status,
    };
    return axiosInstance.post(
      `/other-services/accept-or-reject-by-admin/${data?.id}`,
      params
    );
  },
  otherdashboardStatics: (params) => {
    return axiosInstance.post("/other-service-statics/all-list", params);
  },
  otherprofileStatics: (params) => {
    return axiosInstance.post("/other-service-statics/profile-static", params);
  },
  otherEnquiryDelete: (id) => {
    return axiosInstance.delete(`/other-services/delete/${id}`);
  },
  otherEnquiryAssignAccepter: (id) => {
    return axiosInstance.post(`/other-services/accept-or-reject/${id}`);
  },
  createOtherAssignedEnquirys: (data) => {
    return axiosInstance.post("/assign-other-enquiries/save-and-update", data);
  },
  feedbackform: (data) => {
    return axiosInstance.post("/feedback-form/save-and-update", data);
  },
  feedbackList: (page, size, globalFilter) => {
    let url = "/feedback-form/list";

    // Add query parameters only if they are present
    const params = [];
    if (page !== undefined) {
      params.push(`page=${page + 1}`);
    }
    if (size !== undefined) {
      params.push(`limit=${size}`);
    }
    if (globalFilter !== undefined) {
      params.push(`email=${globalFilter}`);
    }

    // If there are any parameters, add them to the URL
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return axiosInstance.get(url);
  },
  feedbackDelete: (id) => {
    return axiosInstance.delete(`/feedback-form/delete/${id}`);
  },
  creditCard: (data) => {
    return axiosInstance.post("/credit-card-auth-form/save-and-update", data);
  },
  createNewCustomer: (data) => {
    return axiosInstance.post("/customers/save-and-update", data);
  },
  customerList: (params) => {
    let url = "/customers/list";
    return axiosInstance.get(url, { params });
  },
  customerDelete: (id) => {
    return axiosInstance.delete(`/customers/delete/${id}`);
  },
  creditCards: (page, size, additionalParams = {}) => {
    let url = "/credit-card-auth-form/list";

    // Add pagination query parameters
    const params = [];
    if (page !== undefined && page !== null) {
      params.push(`page=${page + 1}`); // Backend is 1-indexed
    }
    if (size !== undefined && size !== null) {
      params.push(`limit=${size}`);
    }

    // Add additional query parameters from the object
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== undefined && value !== null && value !== "") {
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }

    // Construct the final URL
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    // Return the axios request
    return axiosInstance
      .get(url)
      .then((response) => response)
      .catch((error) => {
        console.error("Error in creditCards API call:", error);
        throw error; // Rethrow error for higher-level handling
      });
  },

  creditCardDelete: (id) => {
    return axiosInstance.delete(`/credit-card-auth-form/delete/${id}`);
  },
  countries: () => {
    return axiosInstance.get(`/countries`);
  },
  state: (id) => {
    return axiosInstance.get(`/states/${id}`);
  },
  city: (params) => {
    return axiosInstance.get(`/cities/${params?.country}/${params?.state}`);
  },
  profileFlightStatics: (data) => {
    return axiosInstance.post(`/statics/employee-flight/${data?.id}`, data);
  },
  profileHotelStatics: (data) => {
    return axiosInstance.post(`/statics/employee-hotel/${data?.id}`, data);
  },
  profileOtherStatics: (data) => {
    return axiosInstance.post(
      `/statics/employee-other-service/${data.id}`,
      data
    );
  },
  createNewInvoice: (data) => {
    return axiosInstance.post(`/invoice-main/save-and-update`, data);
  },
  totalInvoice: (data) => {
    return axiosInstance.get(`/invoice-main/list`, { params: data });
  },
  deleteInvoice: (id) => {
    return axiosInstance.delete(`/invoice-main/delete/${id}`);
  },
  invoiceStatics: (params) => {
    return axiosInstance.get(`/invoice-main/statics`, { params });
  },

  agencySalesInvoiceList: (data) => {
    return axiosInstance.get(`/invoice-main/custom-list`, { params: data });
  },
  invoiceMailsender: (invoice_main_id) => {
    return axiosInstance.post(
      `/invoice-main/send-invoice-mail/${invoice_main_id}/airticket`
    );
  },
  paxPendingPayment: (params) => {
    return axiosInstance.get(`/invoice-main/pax-payment-list`, { params });
  },
  getlastmessages: (params) => {
    return axiosInstance.get(`/invoice-main/pax-payment-list`, { params });
  },
  sendOnlyWhatsappMsg: (data) => {
    return axiosInstance.post(`/whatsapp/messages/text`, data);
  },
  getSelectedUserMessages: ({ conversation_id, page }) => {
    return axiosInstance.get(
      `/whatsapp/conversations/${conversation_id}/messages`,
      { params: { page } }
    );
  },
  getSelectedUserMediaMessages: (data) => {
    return axiosInstance.post(`/whatsapp/messages/media`, data);
  },
  markConversationRead: (conversationId) => {
    return axiosInstance.post(
      `/whatsapp/conversations/${conversationId}/mark-read`
    );
  },
  sendBulkMessagesTemplete: (data) => {
    return axiosInstance.post("/whatsapp/messages/bulk-template", data);
  },

  // aiCallingEnquirys: (params) => {
  //   return axiosInstance.get(`/webhook/logs`, { params });
  // },
};

export default userResources;
